import { cn } from "@/lib/utils";
import Image from "next/image";
import { Skeleton } from "@/components/ui/skeleton";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import PlayButton from "./play-button";
import ExpandButton from "./expand-button";
import { GalleryItem } from "../types/common";
import { PlaceholderImage } from "@/components/common/placeholder-image";

type CardProps = {
  item?: GalleryItem;
  onClick?: (d: number | null) => void;
  loading?: boolean;
};

const CardSkeleton = () => {
  return (
    <>
      <Skeleton className="h-full w-full rounded-[40px] bg-primary/5" />
    </>
  );
};

const CardContent = ({ item, onClick }: any) => {
  const isImage = !item.video_link && !!item.image_link;
  return (
    <>
      {item?.image_link ? (
        <Image
          src={item?.image_link}
          fill
          sizes="400px"
          alt="thumbnail" // since no consistent title coming from backend
          objectFit="cover"
          className="rounded-[40px]"
        />
      ) : (
        <PlaceholderImage />
      )}
      <div
        className={cn("absolute inset-0 z-[20] rounded-[40px] bg-black/40")}
      />
      <div
        className={cn(
          "z-[90] flex items-center justify-center opacity-70",
          "absolute bottom-2 left-2 lg:left-[50%] lg:top-[50%] lg:translate-x-[-50%] lg:translate-y-[-50%]",
        )}
      >
        {isImage ? (
          <ExpandButton onClick={onClick} />
        ) : (
          <PlayButton onClick={onClick} />
        )}
      </div>
    </>
  );
};

export default function Card({ item, onClick, loading }: CardProps) {
  return (
    <div className="select-none p-1">
      <div className="flex flex-col gap-6 rounded-[40px] bg-[#0E0D0C] px-4 pb-8 pt-4">
        <div className="relative">
          <AspectRatio ratio={16 / 9}>
            <div className="relative h-full w-full rounded-[40px]">
              {loading ? (
                <CardSkeleton />
              ) : (
                <CardContent item={item} onClick={onClick} />
              )}
            </div>
          </AspectRatio>
        </div>
      </div>
    </div>
  );
}
